exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-48a75d44]{margin:0;padding:0}.item[data-v-48a75d44]:before,.item[data-v-48a75d44]:focus{background:transparent !important}", ""]);

// exports
